import { COLORS } from '../theme';

export default {
  styleOverrides: {
    root: ({ width }) => ({
      borderColor: COLORS.black08,

      '&.MuiDivider-small.MuiDivider-vertical': {
        height: 24,

        '&.MuiDivider-flexItem': {
          alignSelf: 'center',
        },
      },

      ...(width && {
        borderRightWidth: width,
      }),
    }),
  },
};
